import { render, staticRenderFns } from "./EmailTemplateSettings.vue?vue&type=template&id=159b08e0&scoped=true&"
import script from "./EmailTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateSettings.vue?vue&type=style&index=0&id=159b08e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b08e0",
  null
  
)

export default component.exports